import React from "react";
import { Space } from "antd";
import { AxSteps, AxDivider, AxButton } from "@dynata/axiom3";
const { Step } = AxSteps;

class Steps extends React.Component {
  state = {
    current: 0,
  };

  onChange = (current) => {
    console.log("onChange:", current);
    this.setState({ current });
  };
  render() {
    const { current } = this.state;
    return (
      <div className="section" id="steps">
        <h3>Steps</h3>
        <p>
          Steps is a navigation bar that guides users through the steps of a
          task or wizard.
        </p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`
<AxSteps 
  size="small" 
  current={this.state.current} 
  onChange={(val) => this.setState({ current: val })}
>
  <Step title="Step Link" />
  <Step title="Step Link" />
  <Step title="Step Link" status="error" />
  <Step title="Step Link" status="process" />
  <Step title="Step Link" status="finish" />
</AxSteps>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/steps/#API"
                >
                  https://ant.design/components/steps/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td></td>
                  <td>small | medium | large</td>
                  <td>medium</td>
                  <td></td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>To specify the status</td>
                  <td>error | process | finish</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Title of the step</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>className</td>
                  <td>string</td>
                  <td>Additional class to Steps</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>current</td>
                  <td>
                    To set the current step, counting from 0. You can overwrite
                    this state by using <code>status</code> of <code>Step</code>
                  </td>
                  <td>number</td>
                  <td>0</td>
                  <td></td>
                </tr>
                <tr>
                  <td>direction</td>
                  <td>
                    To specify the direction of the step bar,{" "}
                    <code>horizontal</code> or <code>vertical</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>horizontal</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>initial</td>
                  <td>Set the initial step, counting from 0</td>
                  <td>number</td>
                  <td>0</td>
                  <td></td>
                </tr>
                <tr>
                  <td>labelPlacement</td>
                  <td>
                    Place title and description with <code>horizontal</code> or{" "}
                    <code>vertical</code> direction
                  </td>
                  <td>string</td>
                  <td>
                    <code>horizontal</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>percent</td>
                  <td>
                    Progress circle percentage of current step in{" "}
                    <code>process</code> status (only works on basic Steps)
                  </td>
                  <td>number</td>
                  <td>-</td>
                  <td>4.5.0</td>
                </tr>
                <tr>
                  <td>progressDot</td>
                  <td>
                    Steps with progress dot style, customize the progress dot by
                    setting it to a function. labelPlacement will be{" "}
                    <code>vertical</code>
                  </td>
                  <td>
                    <pre>{`boolean | (iconDot, {(index, status, title, description)})
                    =&gt; ReactNode`}</pre>
                  </td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>responsive</td>
                  <td>
                    Change to vertical direction when screen width smaller than{" "}
                    <code>532px</code>
                  </td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>size</td>
                  <td>
                    To specify the size of the step bar, <code>default</code>{" "}
                    and <code>small</code> are currently supported
                  </td>
                  <td>string</td>
                  <td>
                    <code>default</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>
                    To specify the status of current step, can be set to one of
                    the following values: <code>wait</code> <code>process</code>{" "}
                    <code>finish</code> <code>error</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>process</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>type</td>
                  <td>
                    Type of steps, can be set to one of the following values:{" "}
                    <code>default</code>, <code>navigation</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>default</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Trigger when Step is changed</td>
                  <td>(current) =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/steps/#API"
                      >
                        {`<Steps />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="prop-header">
              <p className="props-title">Steps.step</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>description</td>
                  <td>Description of the step, optional property</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>Disable click</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>icon</td>
                  <td>Icon of the step, optional property</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>
                    To specify the status. It will be automatically set by{" "}
                    <code>current</code> of <code>Steps</code> if not
                    configured. Optional values are: <code>wait</code>{" "}
                    <code>process</code> <code>finish</code> <code>error</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>wait</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>subTitle</td>
                  <td>Subtitle of the step</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Title of the step</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxSteps size="small" current={current} onChange={this.onChange}>
  <Step title="Step Link" />
  <Step title="Step Link" />
  <Step title="Step Link" status="error" />
  <Step title="Step Link" status="process" />
  <Step title="Step Link" status="finish" />
</AxSteps>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <div style={{ background: "#f0f0f0", padding: "36px" }}>
          <AxSteps size="small" current={current} onChange={this.onChange}>
            <Step title="Step Link" />
            <Step title="Step Link" />
            <Step title="Step Link" status="error" />
            <Step title="Step Link" status="process" />
            <Step title="Step Link" status="finish" />
          </AxSteps>
        </div>
      </div>
    );
  }
}
export default Steps;
